import { useEffect } from 'react';
import styled from 'styled-components';

const Fondo = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(47, 44, 39, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space.md};
  z-index: 50;
`;

const Caja = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
  padding: ${({ theme }) => theme.space.xl};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.space.lg};
  }
`;

const Titulo = styled.h3`
  font-size: 1.35rem;
  margin-bottom: ${({ theme }) => theme.space.md};
`;

function Modal({ abierto, titulo, onCerrar, children }) {
  useEffect(() => {
    if (!abierto) return undefined;
    const alTeclear = (e) => e.key === 'Escape' && onCerrar();
    document.addEventListener('keydown', alTeclear);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', alTeclear);
      document.body.style.overflow = '';
    };
  }, [abierto, onCerrar]);

  if (!abierto) return null;

  return (
    <Fondo onClick={onCerrar}>
      <Caja role="dialog" aria-modal="true" aria-label={titulo} onClick={(e) => e.stopPropagation()}>
        {titulo && <Titulo>{titulo}</Titulo>}
        {children}
      </Caja>
    </Fondo>
  );
}

export default Modal;
